import { Box, Typography } from "@mui/material";
import React, { useMemo } from "react";

const AssignCertification = ({ selectedCertificate }) => {
  const assignedCertifications = useMemo(
    () => selectedCertificate?.assigned_certifications || [],
    [selectedCertificate]
  );

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: "20px", marginTop: "20px" }}
    >
      {assignedCertifications.length > 0 ? (
        assignedCertifications.map((item, index) => {
          const employeeData = item.assigned_certifications; // Assume this exists in `selectedCertificate`
          console.log(item?.employee_data[0]?.image_url, "item");
          return (
            <Box key={index} sx={{ width: "calc(33.3333% - 14px)" }}>
              <Box
                sx={{
                  padding: "15px",
                  border: "1px solid gray",
                  borderRadius: "10px",
                  width: "100%",
                }}
              >
                {item?.employee_data[0] ? (
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "15px" }}
                  >
                    <Box
                      sx={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "100px",
                        border: "1px solid #0070b6",
                      }}
                    >
                      <img
                        style={{
                          width: "98px",
                          height: "98px",
                          borderRadius: "100px",
                          objectFit: "cover",
                        }}
                        src={
                          process.env.REACT_APP_MEDIA_URL +
                          item?.employee_data[0]?.image
                        }
                        alt="Profile"
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "18px" }}>
                        Name: {item?.employee_data[0]?.name || "N/A"}
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "gray" }}>
                        Email: {item?.employee_data[0]?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Typography>No employee data found</Typography>
                )}

                <Box
                  sx={{
                    borderTop: "1px solid gray",
                    paddingTop: "15px",
                    marginTop: "15px",
                  }}
                >
                  <Typography>
                    {" "}
                    Created At:{" "}
                    {new Date(item?.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </Typography>
                  <Typography>
                    Mark completed: {item?.mark_completed ? "Yes" : "No"}
                  </Typography>
                  <Typography>
                    Progress Percentage: {item?.progress_percentage}
                  </Typography>
                  <Typography>
                    Certification:{" "}
                    {item?.proof_of_certification_url ? (
                      <a
                        href={`https://api.testnet.org.inkitsolutions.com.au${item?.proof_of_certification}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Certification
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })
      ) : (
        <Typography>No assigned certifications available.</Typography>
      )}
    </Box>
  );
};

export default AssignCertification;
